var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "label",
        { staticClass: "permission", attrs: { for: "permission-1" } },
        [
          _c("div", { staticClass: "permission-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.permission_1,
                  expression: "permission_1",
                },
              ],
              attrs: { type: "checkbox", id: "permission-1" },
              domProps: {
                checked: Array.isArray(_vm.permission_1)
                  ? _vm._i(_vm.permission_1, null) > -1
                  : _vm.permission_1,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.permission_1,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.permission_1 = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.permission_1 = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.permission_1 = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "permission-checkbox-style" }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "permission-text" }, [
            _vm._v(
              "\n      Allow users to distribute my content with creator attribution. This\n      permission can increase your sales.\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "permission", attrs: { for: "permission-2" } },
        [
          _c("div", { staticClass: "permission-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.permission_2,
                  expression: "permission_2",
                },
              ],
              attrs: { type: "checkbox", id: "permission-2" },
              domProps: {
                checked: Array.isArray(_vm.permission_2)
                  ? _vm._i(_vm.permission_2, null) > -1
                  : _vm.permission_2,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.permission_2,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.permission_2 = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.permission_2 = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.permission_2 = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "permission-checkbox-style" }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "permission-text" }, [
            _vm._v(
              "\n      I am the author of this content AND I am aware that I cannot sell other\n      people’s creative works.\n      "
            ),
            _c(
              "span",
              { staticClass: "blue", on: { click: _vm.openGuidelines } },
              [_vm._v("See Guidelines")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-button",
        {
          staticClass: "centered",
          attrs: { disabled: !_vm.permission_1 || !_vm.permission_2 },
          on: { click: _vm.confirm },
        },
        [_vm._v("\n    Confirm & Next\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }